export default {
  campaign: {
    _id: '',
    title: '',
    description: '',
    initial_date: '',
    final_date: '',
    status: 'DRAFT',
    segments: [],
    units: [],
    units_configuration: [],
    client_targets_distribution: {
      recent_inactives: 15,
      actives: 60,
      losses: 10,
      at_risk: 10,
      never_bought: 5,
    },
    product_targets: {
      repurchase: 0,
      upsell: 0,
    },
    offer_sales: [],
    offer_schedules: [],
    messages_dispatcher: {
      budget: {
        limiter: 'CAMPAIGN', // DAILY
        channels: {
          sms: 0,
          push: 0,
          email: 0,
          whatsapp: 0,
        },
      },
      settings: {
        campaign_variable_configurations: [],
        model: 'MARIA',
        limit_per_consumer: {
          limiter: 'WEEKLY',
          quantity: 7,
        },
        product_variable_type: 'UNREPETED_BEST_PRODUCT', // BEST_PRODUCT
        schedule_settings: [],
      },
    },
  },
  previousOfferSchedules: [],
  searchedProducts: [],
  importedProducts: [],
  searchProductsValue: '',
  daysOnOffers: {
    days: [],
    max_days_interval_no_offer: 0,
  },
  loadingAction: false,
  campaignVariablesConfiguration: null,
  variablesCharCount: {
    '{nome produto}': 10,
    '{preço 1}': 7,
    '{preço 2}': 7,
    '{desconto}': 3,
    '{leve}': 3,
    '{pague}': 3,
    '{nome do combo}': 10,
    '{cashback absoluto}': 10,
    '{cashback percentual}': 10,
    '{pontos}': 10,
    '{regra min/max}': 10,
    '{inicio validade}': 8,
    '{fim validade}': 8,
    '{regra de expiracao cashback}': 10,
    '[primeiro nome]': 10,
    '[ultimo nome]': 20,
    '[data hoje]': 10,
    '[dia aniversario]': 8,
    '[mes]': 9,
    '[link de optout]': 200,
  },
  channelsCharCount: {
    sms: {
      text: {
        offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_absolute_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        points_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        takepay_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        combo_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
      },
    },
    whatsapp: {
      text: {
        offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_absolute_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        points_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        takepay_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        combo_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
      },
    },
    email: {
      text: {
        offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_absolute_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        points_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        takepay_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        combo_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
      },
    },
    push: {
      text: {
        offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_absolute_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        points_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        takepay_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        combo_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
      },
      title: {
        offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_absolute_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        points_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        takepay_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        combo_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
      },
      inner_message_text: {
        offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_absolute_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        points_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        takepay_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        combo_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
      },
      inner_message_title: {
        offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_absolute_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        cashback_percentage_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        points_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        takepay_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
        combo_offer_sales: {
          repeatableCharCount: 0,
          validityCharCount: 0,
        },
      },
    },
  },
  activeDispatchPanel: 0,
}
